<ham-modal
    [title]="'aumico_annual_report_fx_rates_guide_title' | i18next"
    [saveText]="'aumico_annual_report_fx_rates_guide_close' | i18next"
    [showCloseIcon]="true"
    size="xl"
    (save)="closed.emit()"
    (cancel)="closed.emit()"
>
    <div class="fx-rate-guide">
        <div class="guide-hero">
            <span class="ham-icon guide-hero-icon"><i class="table-icon"></i></span>
            <div class="guide-hero-text">
                <h3>{{ 'aumico_annual_report_fx_rates_guide_headline' | i18next }}</h3>
                <p>{{ 'aumico_annual_report_fx_rates_guide_lead' | i18next }}</p>
            </div>
        </div>

        <!-- A sample of the export as Excel shows it: only the two highlighted columns are read. -->
        <div class="sheet">
            <div class="sheet-chrome">
                <span class="sheet-dot"></span>
                <span class="sheet-dot"></span>
                <span class="sheet-dot"></span>
                <span class="sheet-file">FX Rates.xlsx</span>
            </div>
            <div class="sheet-scroll">
                <table class="sheet-grid">
                    <thead>
                        <tr class="sheet-callouts">
                            <th class="sheet-corner"></th>
                            <th
                                *ngFor="let column of columns"
                                [class.read]="column.read"
                                [class.read-start]="column.edge === 'start'"
                                [class.read-end]="column.edge === 'end'"
                            >
                                <span class="sheet-callout" *ngIf="column.calloutKey">{{
                                    column.calloutKey | i18next
                                }}</span>
                            </th>
                        </tr>
                        <tr class="sheet-letters">
                            <th class="sheet-corner"></th>
                            <th
                                *ngFor="let column of columns"
                                [class.read]="column.read"
                                [class.read-start]="column.edge === 'start'"
                                [class.read-end]="column.edge === 'end'"
                            >
                                {{ column.letter }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="sheet-header-row">
                            <th class="sheet-rownum">1</th>
                            <td
                                *ngFor="let column of columns"
                                [class.read]="column.read"
                                [class.read-start]="column.edge === 'start'"
                                [class.read-end]="column.edge === 'end'"
                            >
                                {{ column.header }}
                            </td>
                        </tr>
                        <tr *ngFor="let row of sampleRows; let index = index">
                            <th class="sheet-rownum">{{ index + 2 }}</th>
                            <td
                                *ngFor="let column of columns"
                                [class.read]="column.read"
                                [class.read-start]="column.edge === 'start'"
                                [class.read-end]="column.edge === 'end'"
                            >
                                {{ cellOf(row, column) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="sheet-legend">
                <span class="sheet-swatch read"></span>
                {{ 'aumico_annual_report_fx_rates_guide_legend_read' | i18next }}
                <span class="sheet-swatch"></span>
                {{ 'aumico_annual_report_fx_rates_guide_legend_ignored' | i18next }}
            </div>
        </div>

        <div class="guide-points">
            <div class="guide-point">
                <span class="guide-point-number">1</span>
                <h4>{{ 'aumico_annual_report_fx_rates_guide_point_file_title' | i18next }}</h4>
                <p>{{ 'aumico_annual_report_fx_rates_guide_point_file_text' | i18next }}</p>
            </div>
            <div class="guide-point">
                <span class="guide-point-number">2</span>
                <h4>{{ 'aumico_annual_report_fx_rates_guide_point_columns_title' | i18next }}</h4>
                <p>{{ 'aumico_annual_report_fx_rates_guide_point_columns_text' | i18next }}</p>
            </div>
            <div class="guide-point">
                <span class="guide-point-number">3</span>
                <h4>
                    {{
                        'aumico_annual_report_fx_rates_guide_point_direction_title'
                            | i18next : { functional: functionalCurrencyName, display: displayCurrencyName }
                    }}
                </h4>
                <p>
                    {{
                        'aumico_annual_report_fx_rates_guide_point_direction_text'
                            | i18next : { functional: functionalCurrencyName, display: displayCurrencyName }
                    }}
                </p>
            </div>
        </div>

        <div class="guide-calc">
            <h4>{{ 'aumico_annual_report_fx_rates_guide_calc_title' | i18next }}</h4>
            <div class="guide-calc-row">
                <span class="ham-icon guide-calc-icon"><i class="calendar-month-icon"></i></span>
                <span>{{ 'aumico_annual_report_fx_rates_guide_calc_closing' | i18next }}</span>
            </div>
            <div class="guide-calc-row">
                <span class="ham-icon guide-calc-icon"><i class="arrows-repeat-icon"></i></span>
                <span>{{ 'aumico_annual_report_fx_rates_guide_calc_average' | i18next }}</span>
            </div>
        </div>
    </div>
</ham-modal>
